import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icons/solid/music-fill.svg'


const _hoisted_1 = { class: "w-full max-w-full sm:max-w-[310px] md:max-w-full lg:max-w-[310px] min-w-[310px]" }
const _hoisted_2 = {
  tabindex: "0",
  class: "shadow-lg h-full bg-white rounded-md border-2 border-gray-200 items-center p-1"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "text-sm truncate ml-3" }
const _hoisted_5 = { class: "text-gray-900 font-semibold truncate" }
const _hoisted_6 = { class: "text-gray-600 truncate" }
const _hoisted_7 = {
  key: 0,
  class: "text-gray-600 truncate text-xs"
}
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "shadow-lg p-1 bg-white rounded-md border-2 border-gray-200 h-full" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"flex\"><div class=\"h-15 w-15 bg-gray-200 relative flex-none rounded animate-pulse\"><img class=\"grayed-icon w-8 h-8 mx-auto translate-y-1/2\" src=\"" + _imports_0 + "\" alt=\"music note icon\"></div><div class=\"ml-3 w-full space-y-2\"><div class=\"bg-gray-200 animate-pulse w-11/12 h-3 rounded-full mt-1\"></div><div class=\"bg-gray-200 animate-pulse w-1/2 h-3 rounded-full\"></div><div class=\"bg-gray-200 animate-pulse w-3/4 h-3 rounded-full\"></div></div></div>", 1)
const _hoisted_11 = [
  _hoisted_10
]

import{
		PlayIcon,
		PlusCircleIcon
	} from '@heroicons/vue/24/solid'

	import{
		Bars3CenterLeftIcon,
		Bars3BottomLeftIcon,
	} from '@heroicons/vue/24/outline'

	// Language
	import {
		useI18n
	} from 'vue-i18n'

	// Store
	import { 
		store as _jobStore
	} from '@/store/job'

	// Types
	import{
		Scene
	} from '@/types'

	// Vue
	import {
		computed,
		inject,
		onMounted,
		ref
	} from "vue"

	
	const __default__ = { name: 'SongResult' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		loading: {
			type: Boolean,
			default: false
		},
		result: {
			type: Object,
			default: null
		},
		scene: {
			type: Boolean,
			default: false
		},
		loadArtwork: {
			type: Boolean,
			default: false
		},
		isCustomSong: {
			type: Boolean,
			default: false
		}
	},
  emits: [
		'loading',
		'play'
	],
  setup(__props, { emit: __emit }) {

	// Icons
	const props = __props

	const {t} = useI18n()
	const jobStore = _jobStore()
	const sceneList = ref(jobStore.job.jobDetails.scenes)
	const selectedSceneIndex = ref<number | null>(null)
	const selectedSceneId = ref<string | null>(null)
	const selectedScene = ref({})
	const showSelect = ref(false)

	const optionsList = computed(() => {
		return sceneList.value.map((scene) => {
			let sceneName = scene['job__JOBS_SCENES__jobID::zctSceneDisplayWeb']

			return {
				label: scene['job__JOBS_SCENES__jobID::zctSceneDisplayWeb'],
				value: scene.recordId
			}
		})
	})

	// const albumImgSrc = ref<string>(props?.result?.artworkUrl)
	// const loading = ref<boolean>(false)

	onMounted(async () => {
		if(!props.loadArtwork) return

		// loading.value = true

		// try {
		// 	albumImgSrc.value = await fetchS3File(props?.result?.artworkUrl)
		// 	loading.value = false
		// }
		// catch(e) {
		// 	console.log(e)
		// }	
	})

	const emit = __emit

	const isPlaying = ref(false)

	const fetchS3File: any = inject('fetchS3File')
	async function playSong() {
		if(props.isCustomSong) return
		
		isPlaying.value = true
		emit('loading', true)
		const signedUrl = await fetchS3File(props.result.songFile)
		const artworkUrl = await fetchS3File(props.result.artworkFile)
		emit('play', {...props.result, signedUrl, artworkUrl})
		emit('loading', false)
	}

	/**
	 * Adds the song to the selected scene
	 * @function addSongToScene
	 */
	function addSongToScene() {

		let scene = sceneList.value[selectedSceneIndex.value]

		scene['job__JOBS_SCENES__jobID::zctSongID'] = props.result?.songId
		scene['job__job_scene__job_song__SONGS__songID::zctAlbumImgPathS3'] = props.result?.artworkFile
		scene['job__job_scene__job_song__SONGS__songID::zctArtistDisplay'] = props.result?.mainArtist
		scene['job__job_scene__job_song__SONGS__songID::name_display'] = props.result?.songName
		scene['job__job_scene__job_song__song__SONGS_INFO__songID::s3JSONSong'] = props.result?.songFile

		jobStore.job.jobDetails.scenes = sceneList.value
	}


return (_ctx: any,_cache: any) => {
  const _component_v_label = _resolveComponent("v-label")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_field = _resolveComponent("v-field")!
  const _component_tw_button = _resolveComponent("tw-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "flex cursor-pointer transition-all duration-200 ease-in-out group",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (showSelect.value = !showSelect.value), ["stop"]))
      }, [
        _createElementVNode("div", {
          class: "h-15 w-15 bg-black relative flex-none rounded",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (playSong()), ["stop"]))
        }, [
          _withDirectives(_createElementVNode("img", {
            src: __props.result?.signedUrl,
            alt: __props.result?.songName,
            class: "object-cover rounded h-full w-full group-hover:opacity-50"
          }, null, 8, _hoisted_3), [
            [_vShow, __props.result?.signedUrl?.length && !__props.loading]
          ]),
          _withDirectives(_createElementVNode("img", {
            class: _normalizeClass(["grayed-icon w-8 h-8 mx-auto translate-y-1/3 top-1/2", {'animate-pulse': __props.result?.signedUrl?.length && __props.loading}]),
            src: _imports_0,
            alt: "list icon"
          }, null, 2), [
            [_vShow, !__props.result?.signedUrl?.length || __props.loading]
          ]),
          (!__props.isCustomSong)
            ? (_openBlock(), _createBlock(_unref(PlayIcon), {
                key: 0,
                class: "h-6 w-6 top-1/2 right-1/2 translate-x-1/2 -translate-y-1/2 absolute text-white hidden group-hover:block"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(__props.result?.songName), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(__props.result?.mainArtist || " "), 1),
          (!__props.isCustomSong)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.result?.additionalArtist || " "), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      (!__props.scene)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["md:hidden flex gap-3 transition-all duration-200 px-2", [showSelect.value ? 'h-22 mt-3' : 'h-0']])
          }, [
            _createVNode(_component_v_field, { class: "flex-1" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_label, { class: "text-sm" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Select Scene ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_select, {
                  modelValue: selectedSceneIndex.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedSceneIndex).value = $event)),
                  name: "selected-scene"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sceneList.value, (scene, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: i,
                        value: i
                      }, _toDisplayString(`${i + 1}. ${scene['job__job_scene__SCENES__sceneID::name_display']}`), 9, _hoisted_8))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_tw_button, {
              onClick: addSongToScene,
              class: "btn-brand font-medium h-11 w-11 mt-9"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(PlusCircleIcon), { class: "text-white h-6" })
              ]),
              _: 1
            })
          ], 2))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !__props.loading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_9, _hoisted_11, 512), [
      [_vShow, __props.loading]
    ])
  ]))
}
}

})